import { render, staticRenderFns } from "./ChangiRecommendsLogo.vue?vue&type=template&id=6656c7cf&scoped=true"
import script from "./ChangiRecommendsLogo.vue?vue&type=script&lang=ts"
export * from "./ChangiRecommendsLogo.vue?vue&type=script&lang=ts"
import style0 from "./ChangiRecommendsLogo.vue?vue&type=style&index=0&id=6656c7cf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6656c7cf",
  null
  
)

export default component.exports